import React from 'react';
import PropTypes from 'prop-types';
import TagSelector from 'components/tagSelector/tag-selector';
import { THEME_NAMES } from 'selectors/tag.selectors';
import ActivitySelector from 'components/activitySelector/activity-selector';
import REDUCER_KEY from 'reducers/reducer.keys';
import {
  Button, Checkbox, Form, Switch
} from 'antd';

const FormItem = Form.Item;

const mapPropsToFields = () => {
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

/**
 * Filter form
 * @version 1.0.1
 */
const ActivityFilterForm = ({
  activeText, clearButtonText, dataSource, form, onResetClick, placeholder, themeName, maxTagCount, reducerKey, showActive, showClearButton, showSearch, showTags, showToggle
}) => {
  const { getFieldDecorator } = form;
  const {
    search, tags, active, allTags
  } = dataSource;

  const layout = {
    inputLayout: {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      }
    }
  };
  return (
    <div className="bhp-form bhp-filter">
      <Form layout="vertical">
        {showSearch && (
          <FormItem {...layout.inputLayout}>
            {getFieldDecorator('search', { initialValue: search })(
              <ActivitySelector
                theme={THEME_NAMES[themeName]}
                placeholder={`Filter ${placeholder}`}
                dropdownMatchSelectWidth={false}
                maxTagCount={maxTagCount}
              />
            )}
          </FormItem>
        )}
        {showTags && (
          <FormItem {...layout.inputLayout}>
            {getFieldDecorator('tags', { initialValue: tags })(
              <TagSelector
                theme={THEME_NAMES[themeName]}
                tagSelectorReducerKey={REDUCER_KEY[reducerKey]}
                placeholder="Filter by Tags"
                dropdownMatchSelectWidth={false}
                maxTagCount={maxTagCount}
              />
            )}
          </FormItem>
        )}
        {showActive && (
          <FormItem {...layout.inputLayout}>
            {getFieldDecorator('active', {
              valuePropName: 'checked',
              initialValue: active
            })(
              <Checkbox>{activeText}</Checkbox>
            )}
          </FormItem>
        )}
        {showToggle && (
          <FormItem {...layout.inputLayout} label={`Filter ${placeholder} that have all the above Tags assigned`}>
            {getFieldDecorator('allTags', {
              initialValue: allTags,
              valuePropName: 'checked'
            })(
              <Switch checkedChildren="All" unCheckedChildren="Any" />
            )}
          </FormItem>
        )}
        <Button.Group>
          {showClearButton && (
            <Button onClick={() => onResetClick()}>
              {clearButtonText}
            </Button>
          )}
        </Button.Group>
      </Form>
    </div>
  );
};

ActivityFilterForm.propTypes = {
  activeText: PropTypes.string.isRequired,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  placeholder: PropTypes.string,
  themeName: PropTypes.string,
  reducerKey: PropTypes.string,
  onResetClick: PropTypes.func,
  showClearButton: PropTypes.bool.isRequired,
  clearButtonText: PropTypes.string.isRequired,
  maxTagCount: PropTypes.number.isRequired,
  showActive: PropTypes.bool.isRequired,
  showSearch: PropTypes.bool.isRequired,
  showTags: PropTypes.bool.isRequired,
  showToggle: PropTypes.bool.isRequired
};

ActivityFilterForm.defaultProps = {
  dataSource: {},
  form: {},
  onFieldsChange() {
  },
  onResetClick() {
  },
  onValuesChange() {
  },
  placeholder: '',
  themeName: '',
  reducerKey: ''
};

export default Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ActivityFilterForm);
